export const storePersist = {
  set: (key, state) => {
    window.localStorage.setItem(key, JSON.stringify(state));
  },
  get: (key) => {
    const result = window.localStorage.getItem(key);
    return JSON.parse(result);
  },
  remove: (key) => {
    window.localStorage.removeItem(key);
  },
  getAll: () => {
    return window.localStorage;
  },
  clear: () => {
    window.localStorage.clear();
  },
};

export default storePersist;

export const localConstant = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  USER_ID: "USER_ID",
  USER_PROFILE: "USER_PROFILE",
  USER_DATA: "USER_DATA",
  API_ACCESS_TOKEN: "API_ACCESS_TOKEN",
  LOCAL_EMAIL: "LOCAL_EMAIL",
  API_ACCESS_TOKEN_OFFLINE: "API_ACCESS_TOKEN_OFFLINE",
  ENTITY_CUSTOMER_ID: "entity_customer_id",
  STATE_LIST: "STATE_LIST",
  OWNER_SIGN_UP_DETAILS: "OWNER_SIGN_UP_DETAILS",
  OPERATOR_SIGN_UP_DETAILS: "OPERATOR_SIGN_UP_DETAILS",
  REFRESH_TOKEN: "REFRESH_TOKEN",
  LOGIN_TIMESTAMP: "LOGIN_TIMESTAMP",
  OWNER_USER_ID: "OWNER_USER_ID",
  OWNER_CUSTOMER_ID: "OWNER_CUSTOMER_ID",
  AGREEMENT_STATUS: "AGREEMENT_STATUS",
  AGREEMENT_ID: "AGREEMENT_ID",
  LANGUAGE: "LANGUAGE",
  TIMESTAMP_FOR_ESIGN: "TIMESTAMP_FOR_ESIGN",
  IS_NATIVE_APP_LAUNCHED: "Is_native_app_launched",
  NATIVE_PLATFORM: "NATIVE_PLATFORM",
  SUPER_ADMIN: "SUPER_ADMIN",
};
